import { useEffect, useState } from "react";
import { useConfig } from "../../hooks/useConfig";
import { faqItems } from "./faqItems";

export function FaqPage() {
  const { config } = useConfig();
  const items = faqItems(config);
  const [open, setOpen] = useState<string | null>(items[0]?.id ?? null);

  useEffect(() => {
    document.title = "FAQ | $TISM";
  }, []);

  return (
    <>
      <section className="shell section">
        <div className="stack stack-4">
          <p className="eyebrow">Questions</p>
          <h1>FAQ</h1>
          <p className="lede">
            What $TISM is, where the money goes, how the airdrop works, and how to spot someone
            pretending to be us.
          </p>
        </div>
      </section>

      <section className="shell" style={{ paddingBottom: "var(--section-y)" }}>
        <div>
          {items.map((item) => {
            const expanded = open === item.id;
            return (
              <div className="qa" key={item.id} id={item.id}>
                <h2 style={{ margin: 0 }}>
                  <button
                    type="button"
                    className="qa__q"
                    aria-expanded={expanded}
                    aria-controls={`${item.id}-answer`}
                    onClick={() => setOpen(expanded ? null : item.id)}
                  >
                    <span>{item.question}</span>
                    <span className="qa__sign" aria-hidden="true">
                      {expanded ? "−" : "+"}
                    </span>
                  </button>
                </h2>
                {expanded ? (
                  <div className="qa__a" id={`${item.id}-answer`}>
                    {item.answer}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
